module.exports = __webpack_public_path__ + "public-ui/img/chevron-left.74a6b442.svg";